export interface CampaignTemplate {
  id: number
  campaign_id: number
  name: string
  slug: string
  ordinal: number
  text: string
  campaign?: {
    id: number
    name: string
    slug: string
  }
  created_at: string
  updated_at: string
}

export interface Campaign {
  id: number
  name: string
  slug: string
  campaign_type: string
  user_id: number
  crm_disposition_mapping_ids: number[]
  campaign_templates: CampaignTemplate[]
  audience_count: string
  created_at: string
  updated_at: string
}

export const mockCampaigns: Campaign[] = [
  {
    id: 1,
    name: 'Missed Appointment Flow',
    slug: 'missed-appointment-flow',
    campaign_type: 'sms',
    user_id: 1,
    crm_disposition_mapping_ids: [1],
    audience_count: '342',
    campaign_templates: [
      {
        id: 101,
        campaign_id: 1,
        name: 'Day 2',
        slug: 'day-2',
        ordinal: 1,
        text: "Turbo Approval: We had you scheduled but didn't connect. Call 5558675309 when you're free and we'll pick back up. Reply STOP to opt out. HELP for info.",
        created_at: '2026-02-16T10:00:00Z',
        updated_at: '2026-02-16T10:00:00Z',
      },
      {
        id: 102,
        campaign_id: 1,
        name: 'Day 3',
        slug: 'day-3',
        ordinal: 2,
        text: 'Turbo Approval: Totally fine if something came up. Your appointment is still open\u2014call 5558675309 when ready. Reply STOP to opt out. HELP for info.',
        created_at: '2026-02-16T10:00:00Z',
        updated_at: '2026-02-16T10:00:00Z',
      },
    ],
    created_at: '2026-02-15T10:00:00Z',
    updated_at: '2026-03-20T14:30:00Z',
  },
  {
    id: 2,
    name: 'Quoted Flow',
    slug: 'quoted-flow',
    campaign_type: 'sms',
    user_id: 1,
    crm_disposition_mapping_ids: [3],
    audience_count: '587',
    campaign_templates: [
      {
        id: 201,
        campaign_id: 2,
        name: 'Day 2',
        slug: 'day-2',
        ordinal: 1,
        text: "Turbo Approval: We completed part of your review earlier. If you'd like to finish up, call 5558675309. Reply STOP to opt out. HELP for info.",
        created_at: '2026-03-02T09:00:00Z',
        updated_at: '2026-03-02T09:00:00Z',
      },
      {
        id: 202,
        campaign_id: 2,
        name: 'Day 4',
        slug: 'day-4',
        ordinal: 2,
        text: 'Turbo Approval: Your quote is still available if you want to go over it. Call 5558675309. Reply STOP to opt out. HELP for info.',
        created_at: '2026-03-02T09:00:00Z',
        updated_at: '2026-03-02T09:00:00Z',
      },
    ],
    created_at: '2026-03-01T09:00:00Z',
    updated_at: '2026-03-25T16:00:00Z',
  },
]

export const dispositionOptions = [
  { label: 'Appointment', value: 1 },
  { label: 'On Call', value: 2 },
  { label: 'Quoted', value: 3 },
  { label: 'Sold', value: 4 },
  { label: 'DNQ', value: 5 },
  { label: 'DNC', value: 6 },
  { label: 'Transferred', value: 7 },
  { label: 'Enrollment', value: 8 },
  { label: 'Lead', value: 9 },
]
